import { format, isValid } from 'date-fns';

import { parseToNoonDate } from '~shared/helpers/datetime';

/** Date-only due dates arrive as UTC midnight ISO; noon-parse avoids US off-by-one (ENR-2139). */
export function formatUpcomingPaymentDueDate(dateString: string): string {
  try {
    const atNoon = parseToNoonDate(dateString);
    if (atNoon == null || !isValid(atNoon)) {
      return '—';
    }

    return format(atNoon, 'MM/dd/yyyy');
  } catch (error) {
    console.error('Failed to format upcoming payment due date', {
      dateString,
      error,
    });
    throw error;
  }
}
